<template>
    <div class="px-0 pb-0 card-body">
        <div class="table-responsive">
            <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns">
                <div :class="{ 'loading-animation' : isLoading }" class="dataTable-container">
                    <table id="genericTable" ref="genericTable" class="table table-flush dataTable-table">
                        <thead class="thead-light">
                            <GenericTableHeader :headers="headers" :list-filters="listFilters" @header-changed="headerChanged" />
                        </thead>
                        <tbody ref="genericTableBody">
                            <tr v-for="(item,index) of items" :key="index">
                                <slot name="row" v-bind="item">
                                </slot>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="px-0 pb-0 card-footer overflow-aux">
        <div class="table-responsive overflow-aux">
            <div class="dataTable-wrapper overflow-aux">
                <div class="dataTable-bottom overflow-aux align-items-center d-lg-flex">
                    <EntriesPerPage v-if="enablePagination" class="column left" :current="pagination.rows" @change="changedRow" />
                    <PagerInformation v-if="enablePagination" class="column center" :total="pagination.total" :current="pagination.currentPage" :rows="pagination.rows" />
                    <Pager v-if="enablePagination" class="column right" :total="totalPages" :current="pagination.currentPage" @changed-page="changedPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import GenericTableHeader from "./GenericTableHeader";
    import Pager from "./Pager.vue";
    import PagerInformation from "./PagerInformation.vue";
    import EntriesPerPage from "./EntriesPerPage.vue";

    export default {
        name: "GenericTable",
        components: {
            GenericTableHeader,
            Pager,
            PagerInformation,
            EntriesPerPage
        },
        props: {
            listFilters: {
                type: Object,
                default: null,
            },
            items: {
                type: Array,
                default: () => [],
            },
            pagination: {
                type: Object,
                default: () => ({
                    total: 200,
                    rows: 10,
                    currentPage: 1,
                    pages: {
                        total: 10,
                        current: 1,
                    },
                    entries: [5, 10, 15, 20, 50, 100, 200]
                })
            },
            enablePagination: {
                type: Boolean,
                default: true
            },
            headers: {
                type: Array,
                default: () => [
                    {
                        title: "",
                        sort: false,
                    }
                ]
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        emits: ['changed-page', 'row-change', 'header-changed'],
        computed: {
            totalPages() {
                return Math.ceil(this.pagination.total / this.pagination.rows);
            }
        },
        watch: {
            items() {
                let table = this.$refs.genericTable;
                table.classList.remove('loading');
            }
            
        },
        methods: {
            changedPage(index) {
                this.$emit('changed-page', index);
            },
            headerChanged(val) {
                this.$emit('header-changed', val);
            },
            changedRow(val) {
                this.$emit('row-change', val);
            }
        }
    }

</script>

<style scoped>

    .loading-animation {
        position: relative;
        opacity: 0.5;
        transition: opacity 0.5s ease-in-out;
    }

    .loading-animation:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        z-index: 2;
        background-image: url('../../assets/img/spinner2.gif');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50px 50px;
    }

    .column {
        flex-grow: 1;
        padding: 0px;
    }

    .left {
        position: relative;
        display: flex;
        justify-content: flex-start;
    }

    .center {
        display: flex;
        justify-content: center;
    }

    .right {
        display: flex;
        justify-content: flex-end;
    }

    .overflow-aux {
        overflow: visible !important;
    }

</style>